import React, { PureComponent } from 'react';
import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Brush
} from 'recharts';

import {TimeSeriesDataProcess} from './TimeSeriesData';


export default class TimeSeriesCard extends PureComponent {

  render() {
    let data = TimeSeriesDataProcess();

    return (

        <ResponsiveContainer width="100%" height={300}>
        <LineChart
          width={1000}
          height={200}
          data={data}
          syncId="anyId"
          margin={{
            top: 10, right: 30, left: 30, bottom: 10,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" padding={{ left: 30, right: 30 }}/>
          <YAxis />
          <Tooltip />
          <Legend verticalAlign="top" height={36}/>
          <Line type="monotone" dataKey="tag" stroke="#8884d8" fill="#8884d8" />
          <Line type="monotone" dataKey="trigger" stroke="#82ca9d" fill="#82ca9d" />
          <Line type="monotone" dataKey="variable" stroke="#E4861C" fill="#E4861C" />
          <Brush />
        </LineChart>
        </ResponsiveContainer>

    );
  }
}
